module.exports = __webpack_public_path__ + "static/img/BZ.4dabbda4.svg";